import { useEffect, useState } from 'react';

/**
 * Returns a version of `value` that only updates after it has stopped changing
 * for `delayMs`, so a search input stays instant while its server query fires
 * only once the user pauses typing.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
